<template>
  <div class="content border-topbottom" id="icons">
    <router-link class="content-classify border-right" tag="div" to="/list/1">
      <div class="content-icon">
        <i class="iconfont">&#xe64c;</i>
      </div>
      <p>餐饮酒店</p>
    </router-link>
    <router-link class="content-classify border-right" tag="div" to="/list/9">
      <div class="content-icon">
        <i class="iconfont">&#xe601;</i>
      </div>
      <p>房产</p>
    </router-link>
    <router-link class="content-classify border-right" tag="div" to="/list/4">
      <div class="content-icon">
        <i class="iconfont">&#xe662;</i>
      </div>
      <p>装修/建材</p>
    </router-link>
    <router-link class="content-classify classify-last" tag="div" to="/list/8">
      <div class="content-icon">
        <i class="iconfont">&#xe682;</i>
      </div>
      <p>汽车</p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'HomeIcons'
}
</script>

<style scoped>
.content{ display: flex; justify-content: space-around; text-align: center; background: url( /static/img/background2.jpg); background-size: 100% 98px; z-index: 0;}
.content-icon .iconfont{ display: block; color: #fff; font-size: 26px; padding: 8px 0;}
.content-icon{ width: 45px; height: 45px; margin-left: auto; margin-right: auto; border-radius: 50%;}
.content-classify:nth-child(1) .content-icon{ background-color: #ff8b38;}
.content-classify:nth-child(2) .content-icon{ background-color: #f02660;}
.content-classify:nth-child(3) .content-icon{ background-color: #1bc4af;}
.content-classify:nth-child(4) .content-icon{ background-color: #e4d02f;}
.content-classify p{ font-size: 12px; margin-top: 5px;}
.content-classify{ width: 33.33%; padding: 10px 0 15px 0;}
.classify-last{ border-right: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Icons.vue